import { RootState } from '../../../../../init-store';
import { isMobileUa } from '../../uatraits';
import { ActiveSettingsSectionKeyType } from './types';

export const selectIsSettingsModalOpened = (state: RootState): boolean => {
    return state.settingsModal.isOpened;
};

export const selectIsHiddenSectionVisible = (state: RootState): boolean => {
    return Boolean(state.settingsModal.isHiddenSectionVisible);
};

export const selectActiveSectionKey = (state: RootState): ActiveSettingsSectionKeyType => {
    return state.settingsModal.activeSectionKey;
};

export const selectIsSettingsV2Shown = (state: RootState) => !isMobileUa(state);

export const selectSettingsSubmodalId = (state: RootState) => state.settingsModal.submodalId;
